import styles from 'modules/report/styles/vertical-barchart.module.css';
import { useMediaQuery } from 'hooks/useMediaQuery';

const rangeAverage = (value) =>
  value == '0'
    ? 'empty'
    : value < 70
    ? 'low'
    : value >= 70 && value <= 180
    ? 'inRange'
    : 'high';

const calcRangePercentage = (value, total) => (value / total) * 100;

export const VerticalBarchart = ({ data }) => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');
  return (
    <div className={styles.verticalBox}>
      <div className={styles.wrapper}>
        <div className={`${styles.wrapper} ${styles.container}`}>
          {data?.map(
            ({
              recordCount,
              highGlucoseCount,
              glucoseAverage,
              inRangeGlucoseCount,
              lowGlucoseCount,
              from,
              to
            }) => (
              <div
                className={styles.column_wrapper}
                key={`${from}-${to}-${recordCount}records`}
              >
                <div className={styles.test_count}>{recordCount}</div>
                <div className={styles.innerColumn}>
                  <div
                    className={styles.high}
                    style={{
                      height: `${calcRangePercentage(
                        highGlucoseCount,
                        recordCount
                      )}%`
                    }}
                  />
                  <div
                    className={styles.inRange}
                    style={{
                      height: `${calcRangePercentage(
                        inRangeGlucoseCount,
                        recordCount
                      )}%`
                    }}
                  />
                  <div
                    className={styles.low}
                    style={{
                      height: `${calcRangePercentage(
                        lowGlucoseCount,
                        recordCount
                      )}%`
                    }}
                  />
                </div>
                <div
                  className={`${styles.avg} ${
                    styles['avg_' + rangeAverage(glucoseAverage.toFixed(0))]
                  }`}
                >
                  {glucoseAverage ? glucoseAverage.toFixed(0) : '-'}
                </div>
                <div className={styles.hour}>
                  {from}-{to}
                </div>
              </div>
            )
          )}
        </div>
        <div className={`${styles.column_wrapper} ${styles.label_column}`}>
          <span className={styles.test_text}>Tests#</span>
          <span className={styles.chart_name}>In Range Distribution </span>
          <span className={styles.avg_text}>
            AVG{!isDesktop && <br />}
            <span className={styles.glocuse_unit}>. (mg/dl)</span>
          </span>
          <span className={styles.hour_text}>Hours</span>
        </div>
      </div>
    </div>
  );
};
